import {h, Component} from 'preact'
import {HomepageElement, Container21HomepageElement, GenericHomepageElementTypes} from '../homepage'
import WidgetColumn from './widget-column'

interface Props {
  parentEl: HTMLElement,
  homepageElement: Container21HomepageElement,
  onChildEnter: () => void,
  onChildLeave: () => void,
  onChange: (change: ElementChange) => void,
  controlUrl: string
}

interface State {
  editingId: string | null,
  column_1: Container21HomepageElement['config']['column_1'],
  column_2: Container21HomepageElement['config']['column_2'],
}

const assignIds = (el: HomepageElement, idx: number) => Object.assign({}, el, {id: idx})


export type ElementChange = Pick<HomepageElement, 'type' | 'config' | 'title'>

export type DonePayload = {idx: number, element: ElementChange}
export type MovePayload = {direction: 'up' | 'down'}
export type VisiblePayload = boolean

export default class ContainerEditor extends Component<Props, State> {
  constructor(props: Props) {
    super()

    this.state = {
      editingId: null,
      column_1: props.homepageElement.config.column_1.map(assignIds),
      column_2: props.homepageElement.config.column_2.map(assignIds),
    }
    this.fireOnChange= this.fireOnChange.bind(this)
  }

  fireOnChange() {
    this.props.onChange({
      type: 'container_2_1',
      config: {
        column_1: this.state.column_1,
        column_2: this.state.column_2,
      }
    })
  }

  render({ homepageElement, controlUrl }: Props, {column_1, column_2}: State) {
    return <div>
      <WidgetColumn
        container={`.homepage-widget-container--index-${homepageElement.id} .homepage-widget-container--container-2-1-column_1`}
        classPrefix='homepage-widget-container--container-2-1-column_1-index-'
        elements={column_1}
        controlUrl={controlUrl}
        widgetList={[{
          type: 'html_widget',
          title: 'HTML widget',
          description: 'Custom widget by HTML'
        }, {
          type: 'knowledge_base',
          title: 'Knowledge Base',
          description: 'Navigation cards to knowledge base parent categories'
        }, {
          type: 'community_category',
          title: 'Community Category',
          description: 'Navigation cards to community parent categories'
        }, {
          type: 'category_and_topics_stream_only',
          title: 'Community content stream',
          description: 'Contains list of community categories and stream of recent content'
        }]}
        onChange={(column_1: Container21HomepageElement['config']['column_1']) => this.setState({column_1}, this.fireOnChange)}
        onChildMouseOut={this.props.onChildLeave}
        onChildMouseOver={this.props.onChildEnter}
        nested
      />

      <WidgetColumn
        container={`.homepage-widget-container--index-${homepageElement.id} .homepage-widget-container--container-2-1-column_2`}
        controlUrl={controlUrl}
        widgetList={[{
          type: 'leaderboard_points',
          title: 'Leaderboard',
          description: 'A list of users that gain the most points'
        }, {
          type: 'html_widget',
          title: 'HTML widget',
          description: 'Custom widget by HTML'
        }, {
          type: 'badges',
          title: 'Awarded Badges widget',
          description: 'A list of users that recently received a badge'
        }, {
          type: GenericHomepageElementTypes.announcement_card,
          title: 'Announcement card',
          description: 'One topic featured by moderator tag \'featured_side\''
        }, {
          type: 'tag_cloud',
          title: 'Tag cloud',
          description: 'A cloud of your most used tags'
        }, {
          type: 'solved_topics',
          title: 'Solved Topics',
          description: 'A list of topics with a best answer assigned'
        }, {
          type: 'most_liked',
          title: 'Most liked',
          description: 'A list of users that received the most likes'
        }, {
          type: 'knowledge_base',
          title: 'Knowledge Base',
          description: 'Navigation cards to knowledge base parent categories'
        }, {
          type: 'community_statistics',
          title: 'Community Statistics',
          description: 'Shows community wide statistics'
        }]}
        classPrefix='homepage-widget-container--container-2-1-column_2-index-'
        elements={column_2}
        onChange={(column_2: Container21HomepageElement['config']['column_2']) => this.setState({column_2}, this.fireOnChange)}
        onChildMouseOut={this.props.onChildLeave}
        onChildMouseOver={this.props.onChildEnter}
        nested
      />
    </div>
  }
}
